import React, {Component} from 'react';
import {FormattedDate, FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import 'react-picky/dist/picky.css';
import get from 'get-value';
import PropTypes from 'prop-types';
import {
    batteryProblemTypes,
    countryGroups,
    domains,
    getDealerFormTypes,
    getEditorFormTypes,
    getSgEditorFormTypesOptions,
    requestOfCourtesyCarType,
    customerFollowUpType,
    srcRequestType
} from '../../../constants/Utils';
import HistoryOrderTable from './HistoryOrderTable';
import {clearAlerts} from '../../../actions/alertsActions';
import commonMessages from '../../../intl/common/commonMessages';
import historyMessages from '../../../intl/sparePartsOrders/historyMessages';
import formTypeMessages from '../../../intl/common/formTypeMessages';
import formStatesMessages from '../../../intl/common/formStatesMessages';
import {
    updateSparePartsUserHistoryPreference
} from '../../../actions/orders/actionSparePartsPreferences';
import Loader from '../../Loader';
import PageHeader from '../../common/PageHeader';
import moment from 'moment';
import {StyledPicky} from '../../common/StyledComponents';
import DatePickerTableComponent from '../../common/datePicker/DatePickerTableComponent';
import checkRoles from '../../common/roleChecker/RoleChecker';
import {fillNumberFiveZero} from '../../../utils/utils';
import {moduleRoles} from '../../../utils/roles';
import batteryProblemTypeMessages from '../../../intl/sparePartsOrders/batteryProblemTypeMessages';
import clientTypeMessages from '../../../intl/technicalDocumentations/clientTypeMessages';

const domain = domains.SPARE_PARTS;

class HistoryOrderPage extends Component {
    constructor(props) {
        super(props);
        const {intl, loggedUser, loggedUser: {roles}} = props;

        const isSgEditor = moduleRoles.isSGEditorOrder(roles);
        const isEditor = !isSgEditor && moduleRoles.isEditorOrder(roles);
        const isDealer = !isSgEditor && !isEditor && moduleRoles.isDealerOrder(roles);

        const managedGroups = get(props, `loggedUser.roles.${domain}.dealer`) ? [get(props, 'loggedUser.group', 'XX')] : moduleRoles.getEditorGroups(domain, get(props, 'loggedUser.roles', {})).map(({group}) => group);
        this.state = {
            columnLibrary: [
                {
                    id: 'created',
                    accessor: 'created',
                    message: historyMessages.TABLE_ORDER_CREATION_TIME,
                    Filter: ({filter, onChange}) => {
                        let value = filter && filter.value;
                        if (typeof value === 'string') {
                            value = moment(value).toDate();
                        }
                        return <DatePickerTableComponent
                            value={value || undefined}
                            onChange={onChange}
                            filter={filter}/>;
                    },
                    Cell: e => <FormattedDate value={new Date(e.value)}/>,
                },
                {
                    id: 'creatorIpn',
                    accessor: 'creatorIpn',
                    message: historyMessages.TABLE_CREATED_BY,
                },
                {
                    id: 'clientId',
                    accessor: 'clientId',
                    message: historyMessages.TABLE_CLIENT_ID,
                    Cell: e => e.value && String(e.value).padStart(6, "0")
                },
                {
                    id: 'region',
                    accessor: 'region',
                    message: historyMessages.TABLE_REGION,
                },
                {
                    id: 'countryCode3',
                    accessor: 'countryCode3',
                    message: historyMessages.TABLE_COUNTRY_CODE_3,
                },
                {
                    id: 'dealerNumber',
                    accessor: 'dealerNumber',
                    message: historyMessages.TABLE_DEALER_NUMBER,
                    Cell: e => e.value && String(e.value).padStart(8, "0")
                },
                {
                    id: 'orderType',
                    accessor: 'orderType',
                    message: historyMessages.TABLE_ORDER_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}
                        >
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {isDealer && getDealerFormTypes(get(loggedUser, 'roles.SPARE_PARTS.dealer.formsPermission')).map((key, index) =>
                                <option key={index} value={key}>
                                    {formTypeMessages[key] ? intl.formatMessage(formTypeMessages[key]) : key}
                                </option>)
                            }
                            {isEditor && getEditorFormTypes(domain, get(loggedUser, 'roles.SPARE_PARTS.editor.groupPermission')).map((key, index) =>
                                <option key={index} value={key}>
                                    {formTypeMessages[key] ? intl.formatMessage(formTypeMessages[key]) : key}
                                </option>)
                            }
                            {isSgEditor && getSgEditorFormTypesOptions(domain, get(loggedUser, 'roles.SPARE_PARTS.sgEditor.sgPermission')).map((key, index) =>
                                <option key={index} value={key}>
                                    {formTypeMessages[key] ? intl.formatMessage(formTypeMessages[key]) : key}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{formTypeMessages[e.value] ? intl.formatMessage(formTypeMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'requestOfCourtesyCar',
                    accessor: 'requestOfCourtesyCar',
                    message: historyMessages.REQUEST_OF_COURTESY_CAR,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {requestOfCourtesyCarType.map((key, index) =>
                                <option key={index} value={key}>
                                    {commonMessages[key] ? intl.formatMessage(commonMessages[key]) : key}
                                </option>)}
                        </select>
                    ),
                    Cell: e =>
                        <div>{commonMessages[e.value] ? intl.formatMessage(commonMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'bin',
                    accessor: 'bin',
                    message: historyMessages.TABLE_BIN,
                },
                {
                    id: 'invoiceNumber',
                    accessor: 'invoiceNumber',
                    message: historyMessages.TABLE_INVOICE_NUMBER,
                },
                {
                    id: 'partNo',
                    accessor: 'partNo',
                    message: historyMessages.TABLE_PART_NO,
                },
                {
                    id: 'managementGroup',
                    accessor: 'managementGroup',
                    message: historyMessages.TABLE_MANAGEMENT_GROUP,
                },
                {
                    id: 'batteryProblemType',
                    accessor: 'batteryProblemType',
                    message: historyMessages.TABLE_PROBLEM_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {[...new Set(managedGroups.reduce((acc, cur) => batteryProblemTypes[cur] ? acc.concat(batteryProblemTypes[cur]) : acc, []))].map((type, index) =>
                                <option key={index} value={type}>
                                    {batteryProblemTypeMessages[type] ? intl.formatMessage(batteryProblemTypeMessages[type]) : type}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{batteryProblemTypeMessages[e.value] ? intl.formatMessage(batteryProblemTypeMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'status',
                    accessor: 'status',
                    message: historyMessages.TABLE_STATUS,
                    sortable: false,
                    filterable: false,
                    Cell: e =>
                        <div>{formStatesMessages[e.value] ? intl.formatMessage(formStatesMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'customerFollowUp',
                    accessor: 'customerFollowUp',
                    message: historyMessages.TABLE_CUSTOMER_FOLLOW_UP,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {customerFollowUpType.map((key, index) =>
                                <option key={index} value={key}>
                                    {commonMessages[key] ? intl.formatMessage(commonMessages[key]) : key}
                                </option>)}
                        </select>
                    ),
                    Cell: e => <div>{e.value == null ? '' : (get(e, 'value.required') ? intl.formatMessage(commonMessages.YES) : intl.formatMessage(commonMessages.NO))}</div>
                },
                {
                    id: 'solutionGroup',
                    accessor: 'solutionGroup',
                    message: historyMessages.TABLE_SOLUTION_GROUP,
                    Cell: e =>
                        <div> {e.value && !e.value.canForwardToDealer && isDealer ? '' : get(e, 'value.name', '')}</div>
                },
                {
                    id: 'lastEditor',
                    accessor: 'lastEditor',
                    message: historyMessages.TABLE_LAST_EDITOR,
                },
                {
                    id: 'clientType',
                    accessor: 'clientType',
                    message: historyMessages.TABLE_TYPE_OF_CLIENT,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {
                                Object.keys(clientTypeMessages).map((key, index) =>
                                    <option key={index} value={key}>
                                        {clientTypeMessages[key] ? intl.formatMessage(clientTypeMessages[key]) : key}
                                    </option>
                                )
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{clientTypeMessages[e.value] ? intl.formatMessage(clientTypeMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'srcRequest',
                    accessor: 'srcRequest',
                    message: historyMessages.TABLE_SRC_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {srcRequestType.map((key, index) =>
                                <option key={index} value={key}>
                                    {commonMessages[key] ? intl.formatMessage(commonMessages[key]) : key}
                                </option>)}
                        </select>
                    ),
                    Cell: e =>
                        <div>{commonMessages[e.value] ? intl.formatMessage(commonMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'srcClaimN',
                    accessor: 'srcClaimN',
                    message: historyMessages.TABLE_SRC_N,
                }
            ],
        };


        if(isDealer) {
            this.state.columnLibrary = this.state.columnLibrary.filter(column => column.id !== 'managementGroup' && column.id !== 'countryCode3');
        }

        if(!managedGroups.includes(countryGroups.IT)) {
            this.state.columnLibrary = this.state.columnLibrary.filter(column => column.id !== 'requestOfCourtesyCar');
        }
    }

    selectMultipleOption = (value) => {
        this.props.updateSparePartsUserHistoryPreference(this.props.loggedUser.ipn,
            this.state.columnLibrary.filter(item => !value.some(value => value.id === item.id)).map(column => column.id))
    };

    render() {
        const {intl, sparePartsPreferences} = this.props;
        const {columnLibrary} = this.state;
        if (sparePartsPreferences.isLoading) {
            return <Loader/>;
        }
        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...historyMessages.TITLE}/>}/>
                <div className="d-flex justify-content-end mb-3">
                    <div className="col-xl-4 col-lg-7 col-md-9 col-sm-12">
                        <span className="font-weight-bold"><FormattedMessage {...historyMessages.VISIBLE_COLUMNS}/>{':'}</span>
                        <StyledPicky
                            value={columnLibrary.filter(item => !get(sparePartsPreferences, 'menuHistory', {default: []}).includes(item.id)).map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            options={columnLibrary.map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            onChange={this.selectMultipleOption}
                            open={false}
                            valueKey="id"
                            labelKey="message"
                            multiple={true}
                            includeSelectAll={true}
                            selectAllText={<FormattedMessage {...commonMessages.SELECT_ALL}/>}
                            manySelectedPlaceholder={"%s " + intl.formatMessage(commonMessages.SELECTED)}
                            allSelectedPlaceholder={"%s " + intl.formatMessage(commonMessages.SELECTED)}
                            includeFilter={false}
                            dropdownHeight={600}
                        />
                    </div>
                </div>
                <HistoryOrderTable
                    columns={columnLibrary.filter(item => !get(sparePartsPreferences, 'menuHistory', {default: []}).includes(item.id))}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loggedUser: state.profile.userDetail,
    sparePartsPreferences: state.sparePartsPreferences
});


HistoryOrderPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    updateSparePartsUserHistoryPreference: PropTypes.func.isRequired,
    loggedUser: PropTypes.object.isRequired,
    intl: PropTypes.any.isRequired,
    sparePartsPreferences: PropTypes.object.isRequired,
};

export default checkRoles(connect(mapStateToProps, {
    clearAlerts,
    updateSparePartsUserHistoryPreference,
})(injectIntl(HistoryOrderPage)), ['SP_EDITOR', 'SP_DEALER', 'SP_SG_EDITOR']);

